const Forbidden = () => (
  <div className="p-6 text-center bg-white text-gray-800 dark:bg-gray-900 dark:text-gray-100 min-h-screen flex flex-col items-center pt-20">
    <h1 className="text-2xl font-bold mb-2">403 - Forbidden</h1>
    <p className="text-gray-600 dark:text-gray-400">
      You do not have permission to access this page.
    </p>
  </div>
);

export default Forbidden;
